import React from 'react'
import { Button, Icon, Modal } from 'antd'
import { Link } from 'react-router-dom'

export const CreateButton = props => (
  <Button type='primary' {...props}><Icon type='plus' />Создать</Button>
)

export const TableRowEditButton = props => (
  <Link to={props.to}><Icon type='edit' style={{ marginRight: '6px' }} />{props.name ? props.name : 'Управление'}</Link>
)

export const TableRowModalEditButton = props => (
  <Button type='link' icon='edit' onClick={props.onClick} style={{ marginRight: '6px' }}>Управление</Button>
)

export class TableRowDeleteButton extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  handleOnClick() {
    const handleOnOk = () => { this.props.deleteAction() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }
  render() {
    return <a href='#' onClick={this.handleOnClick}><Icon type='delete' style={{ marginRight: '6px' }} />Удалить</a>
  }
}



// WEBPACK FOOTER //
// src/components/AppButton/index.jsx